module.exports = __webpack_public_path__ + "img/tw-home-button.4bbe1717.png";